module.exports = "./assets/images/avatar-10.svg";